import { get } from 'lodash';
import React from 'react';
import { Button, Image, SizeFittingTable } from 'src/components/Antd';
import { TableNumberInputWithSlash } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { SectionWrapper } from 'src/components/Layouts';
import { isNumber } from 'src/tools/helper';
import { EnumTablePosition } from 'src/types/common/common';
import {
  //IOrderPackItem,
  EType,
} from 'src/types/common/order';
import css from './css.module.less';
//import { ChangeSize } from 'src/tools/customHooks';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import CustomizationRow from 'src/pages/Order/Components/ExclusiveCustom';
import { accMul } from 'src/tools/math';
import { EExternalRef, getMinSetNumber } from '../tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const ReadyToPick = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    data,
    onQuantityChange,
    onPickItems,
    disabled,
    onQuantityPickAll,
    decimalPosition,
  } = props;

  const amount = (data || []).reduce((pre, now) => {
    if (now.productUuid) {
      const { amount } = now;
      return pre + amount;
    }
    return pre;
  }, 0);

  const [selectedKeys, setSelectedKeys] = React.useState(
    (data || []).reduce((p, c) => (c.productUuid ? p.concat(c.uuid) : p), []),
  );
  // const currentKeys = React.useMemo(() => {
  //   return data.map((i) => i.uuid);
  // }, [data]);
  // React.useEffect(() => {
  //   setSelectedKeys()
  // }, [currentKeys]);
  // console.log('123');
  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (selected) => {
      setSelectedKeys(selected);
      const qtyZeroItem = data.findIndex((item) => Number(item.quantity) === 0);
      if (qtyZeroItem !== -1) {
        onQuantityPickAll(
          data.map((item) =>
            Number(item.quantity) === 0
              ? { ...item, quantity: item.amount }
              : item,
          ),
        );
      }
    },
    getCheckboxProps: (record) => {
      const isParent = get(record, EExternalRef.isParent);

      return {
        disabled: isParent || disabled,
      };
    },
  };

  const expandedRows = (data || []).map((i) => i.uuid);
  const handleOnPickAll = () => {
    const uuids = data
      .filter((i) => !i[EExternalRef.isParent])
      .map((i) => i.uuid);
    //console.log('uuids', uuids);
    // setSelectedKeys(uuids);
    const _picks = data.filter((i) => uuids.includes(i.uuid));
    const picks = _picks.map((i) => {
      const { amount } = i;
      return { ...i, quantity: amount };
    });
    onPickItems(picks, () => {
      setSelectedKeys([]);
    });
  };
  const handleOnPick = () => {
    const _picks = data.filter((i) => selectedKeys.includes(i.uuid));
    const picks = _picks.map((i) => {
      const { quantity } = i;
      return { ...i, amount: quantity };
    });
    onPickItems(picks, () => {
      setSelectedKeys([]);
    });
  };

  const handleQuantityChange = (
    quantity: number,
    index: number,
    uuid: string,
  ) => {
    onQuantityChange(quantity, index, uuid);
    if (Number(quantity) === 0) {
      setSelectedKeys(selectedKeys.filter((v) => uuid !== v));
    }
    if (Number(quantity) > 0) {
      setSelectedKeys(
        selectedKeys.indexOf(uuid) !== -1
          ? selectedKeys
          : [...selectedKeys, uuid],
      );
    }
  };

  const tableName = 'OrderDetailReadyToPickTable';
  return (
    <SectionWrapper
      title={
        <div
          title={replaceI18nVariables(
            getI18n('allOrders.orderDetail.readytopick_return_title'),
            amount,
          )}>
          {replaceI18nVariables(
            getI18n('allOrders.orderDetail.readytopick_return_title'),
            amount,
          )}
        </div>
      }
      containerClassName={css.wrapper}>
      <div className={css.container}>
        <SizeFittingTable
          rowKey='uuid'
          pagination={false}
          dataSource={data}
          className={css.readyToPickTable}
          id={tableName}
          columns={col(handleQuantityChange, data, {
            getI18n,
            decimalPosition,
          })}
          rowSelection={rowSelection}
          rowClassName={(record, index) => {
            const isParent = get(record, EExternalRef.isParent);
            return isParent ? css.parentRow : css.childRow;
          }}
          expandable={{
            expandedRowClassName: (record) => {
              const isParent = get(record, EExternalRef.isParent);
              const isChild = get(record, EExternalRef.isChild);
              const isLast = get(record, EExternalRef.isLast);
              //console.log(record);
              const shouldHideBottomLine = (isParent || isChild) && !isLast;
              return `${css.expandedRow} ${
                shouldHideBottomLine ? css.hideBottomLine : ''
              }`;
            },
            expandedRowKeys: expandedRows,
            expandIconColumnIndex: -1,
            indentSize: 0,
            expandedRowRender: (record, index) => {
              //const isParent = get(record, EExternalRef.isParent);
              const isChild = get(record, EExternalRef.isChild);

              const customisationItem =
                get(record, 'customisation.items') || [];
              const exclusiveCustomData = (customisationItem || []).map(
                (item) => ({
                  title: `${item.title} : ${(item.values || []).join(',')}`,
                }),
              );
              if (isChild) {
                return <React.Fragment />;
              }
              if (!customisationItem.length) {
                return <React.Fragment />;
              }

              return (
                <React.Fragment>
                  <div className={css.customizationLine}>
                    <CustomizationRow data={exclusiveCustomData} />
                  </div>
                  {/* <div className={css.customizationLine}>
                    <div className={css.customization}>
                      <div className={css.customizationFront}></div>
                      <div className={css.customizationText}>
                        專屬定制：刻字”XXX”
                      </div>
                    </div>
                    <div className={css.customizationPrice}>100.00</div>
                  </div>{' '}
                  <div className={css.customizationLine}>
                    <div className={css.customization}>
                      <div className={css.customizationFront}></div>
                      <div className={css.customizationText}>
                        專屬定制：刻字”XXX”
                      </div>
                    </div>
                   
                  </div> */}
                </React.Fragment>
              );
            },
            // rowExpandable: (record) =>
            //   record.productSetSku ||
            //   record.customisation ||
            //   record.productSetName,
          }}
        />
        {/* <div className={css.tip}>* Incomplete Set</div> */}
        <IncompleteSet data={data} />
      </div>
      <div className={css.bottomBtnContainer}>
        <Button
          className={css.pickAndPack}
          type='primary'
          onClick={handleOnPick}
          disabled={!selectedKeys.length || disabled}>
          {getI18n('reports.reportlist.orderLineItemsReport') ||
            'Pick Selected Items'}
        </Button>
        <Button
          disabled={disabled}
          className={css.pickAll}
          onClick={handleOnPickAll}>
          {getI18n('allOrders.orderDetail.readytopick_return_pickAllBtn')}
        </Button>
      </div>
    </SectionWrapper>
  );
};
export default ReadyToPick;
const widthDict = {
  item: { minWidth: 180 },
  sku: { minWidth: 140 },
  qty: {
    width: 110,
  },

  paid: { width: 90 },
};
const col = (onChange, data, { getI18n, decimalPosition }) => {
  return [
    {
      title: getI18n(
        'allOrders.orderDetail.readytopick_colreturn_itemsobj_title',
      ),
      key: 'Items (Store)',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { productName } = record;
        const isChild = get(record, EExternalRef.setUuid);

        const thumbnailUrl = get(record, 'image.url');
        return (
          <div
            className={css.productNameContainer}
            style={{ paddingLeft: isChild ? 45 : 0 }}>
            {/* {thumbnailUrl && ( */}
            <Image
              style={{
                marginRight: 12,
                minWidth: 40,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />
            {/* )} */}
            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                <div className={css.text}>
                  {productName || '-'}
                  {/* {productName}
                  {productName} */}
                </div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['item'],
    },
    {
      title: getI18n(
        'allOrders.orderDetail.readytopick_colreturn_skuobj_title',
      ),
      key: 'SKU',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { sku } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={sku || '-'}>{sku}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['sku'],
    },
    {
      titleGenerate: () => (
        <span>
          <EditIcon />{' '}
          {getI18n(
            'allOrders.orderDetail.readytopick_colreturn_qtyobj_titleGenerate',
          )}
        </span>
      ),
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index) => {
        // console.log('record', record);
        const { amount, quantity, uuid } = record;
        const isParent = record[EExternalRef.isParent];
        if (isParent) {
          return <ParentQty set={record} data={data} />;
        }
        //console.log(amount, quantity);
        return (
          <TableNumberInputWithSlash
            itemProps={{
              min: 0,
              //onChangeWhenOnBlur: true,
              max: amount,
              onBlur: (e) => {
                onChange(e, index, uuid);

                //console.log(e, '123123123');
              },
              backPart: (
                <div className={css.suffixPart}>
                  /
                  <NoWrapContainer>
                    <GlobalTooltip title={amount}>
                      {amount || '-'}
                    </GlobalTooltip>
                  </NoWrapContainer>
                </div>
              ),
            }}
            value={quantity}
            // onChange={(quantity) => {
            //   onChange(quantity, index, uuid);
            // }}
            label={quantity == amount ? amount : `${quantity || 0}/${amount}`}
            //  backPart={<div className={css.backPart}>/9999</div>}
          />
          // <NoWrapContainer>
          //   <GlobalTooltip title={amount || '-'}>{amount}</GlobalTooltip>
          // </NoWrapContainer>
        );
      },
      ...widthDict['qty'],
    },
    {
      titleGenerate: () => (
        <div>
          <div>
            {getI18n(
              `allOrders.orderDetail.readytopick_colreturn_paidobj_titleGenerate1`,
            )}
          </div>
          <div>
            {getI18n(
              `allOrders.orderDetail.readytopick_colreturn_paidobj_titleGenerate2`,
            )}
          </div>
        </div>
      ),
      key: 'Paid',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { paidPrice, type } = record;
        if (type === EType.Gift) {
          return (
            <span>
              {getI18n(
                `allOrders.orderDetail.readytopick_colreturn_paidobj_childGenerate_Etypejudge`,
              )}
            </span>
          );
        }
        const num = isNumber(paidPrice)
          ? paidPrice.toFixed(decimalPosition)
          : '-';

        const isParent = record[EExternalRef.isParent];
        const isChild = record[EExternalRef.isChild];

        if (isChild) {
          return (
            <ChildPrice
              data={data}
              simple={record}
              decimalPosition={decimalPosition}
            />
          );
        }
        if (isParent) {
          return (
            <ParentPrice
              data={data}
              set={record}
              decimalPosition={decimalPosition}
            />
          );
        }
        return (
          <NoWrapContainer className={css.paidPrice}>
            <GlobalTooltip title={num}>{num || '-'}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['paid'],
    },
  ];
};

export const ParentQty = (props) => {
  const { set, data } = props;
  //
  const { uuid, amount, cannotAssemble } = set;
  const children = data.filter((i) => i[EExternalRef.setUuid] === uuid);
  const { min, isEntireSet } = getMinSetNumber(children);
  const isEqual = min === amount;
  const render = () => {
    if (cannotAssemble) {
      return '*';
    }
    if (isEqual) {
      return amount;
    } else if (isEntireSet) {
      return `${min}`;
    } else {
      if (min === 0) {
        return '*';
      } else {
        return `${min}*`;
      }
    }
  };
  return render();
};
//canAssemble;
const ParentPrice = (props) => {
  const { set, data, decimalPosition } = props;
  //
  const { uuid, amount, paidPrice, cannotAssemble } = set;
  const children = data.filter((i) => i[EExternalRef.setUuid] === uuid);
  const { min, isEntireSet } = getMinSetNumber(children);
  const isEqual = min === amount;

  const render = () => {
    if (cannotAssemble) {
      return <React.Fragment />;
    }
    if (isEqual) {
      const num = accMul(amount, paidPrice).toFixed(decimalPosition);
      return (
        <NoWrapContainer className={css.paidPrice}>
          <GlobalTooltip title={num}>{num || '-'}</GlobalTooltip>
        </NoWrapContainer>
      );
    }
    if (isEntireSet) {
      const num = accMul(min, paidPrice).toFixed(decimalPosition);
      return (
        <NoWrapContainer className={css.paidPrice}>
          <GlobalTooltip title={num}>{num || '-'}</GlobalTooltip>
        </NoWrapContainer>
      );
    }
    return <React.Fragment />;
  };
  return render();
};

const ChildPrice = (props) => {
  const { simple, data, decimalPosition } = props;
  const setUuid = get(simple, EExternalRef.setUuid);
  const paidPrice = get(simple, 'paidPrice');
  const quantity = get(simple, 'quantity');

  const parent = data.find((i) => i.uuid === setUuid);
  const cannotAssemble = get(parent, 'cannotAssemble');
  if (cannotAssemble) {
    const num = accMul(quantity, paidPrice).toFixed(decimalPosition);
    return (
      <NoWrapContainer className={css.paidPrice}>
        <GlobalTooltip title={num}>{num || '-'}</GlobalTooltip>
      </NoWrapContainer>
    );
  }
  // const amount = get(simple, 'amount');
  const allChildren = data.filter((i) => i[EExternalRef.setUuid] === setUuid);
  const { isEntireSet } = getMinSetNumber(allChildren);
  if (!isEntireSet) {
    const num = accMul(quantity, paidPrice).toFixed(2);
    return (
      <NoWrapContainer className={css.paidPrice}>
        <GlobalTooltip title={num}>{num || '-'}</GlobalTooltip>
      </NoWrapContainer>
    );
  } else {
    return <React.Fragment />;
  }
};

const IncompleteSet = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { data } = props;
  const hasCannotAssemble = data.filter((i) => i.cannotAssemble);
  if (hasCannotAssemble.length > 0) {
    return (
      <div className={css.tip}>
        {getI18n(
          `allOrders.orderDetail.readytopick_IncompleteSet_hasCannotAssembleLength`,
        )}
      </div>
    );
  }
  const groupedChildren = data.reduce((pre, now) => {
    const setUuid = now[EExternalRef.setUuid];
    if (setUuid) {
      if (!pre[setUuid]) {
        return { ...pre, [setUuid]: [now] };
      } else {
        return { ...pre, [setUuid]: [...pre[setUuid], now] };
      }
    }
    return pre;
  }, {});
  // console.log('groupedChildren', groupedChildren);
  const hasIncomplete = Object.keys(groupedChildren).find((k) => {
    const children = groupedChildren[k];
    // console.log('children', children);
    const { isEntireSet } = getMinSetNumber(children);

    return !isEntireSet;
  });

  return hasIncomplete ? (
    <div className={css.tip}>
      {getI18n(
        `allOrders.orderDetail.readytopick_IncompleteSet_hasCannotAssembleLength`,
      )}
    </div>
  ) : null;
};
